import Vue from 'vue'
import Notifications from 'vue-notification'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import App from './App.vue'
import store from './store'
import router from './router'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './main.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebook, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faFacebook)
library.add(faInstagram)
library.add(faYoutube)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Notifications)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
